var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[(_vm.view == 'home')?_c('HomeVue'):_vm._e(),(_vm.view == 'mantenimiento')?_c('MaintenanceVue',{on:{"mtdViewFooter":_vm.mtdViewFooter}}):_vm._e()],1),_c('FooterVue',{attrs:{"view":_vm.view,"booFooter":_vm.booFooter},on:{"setView":_vm.setView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }